import Evaluator, { EvaluatorContext } from "./Evaluator"
import EvaluateRequest from "../EvaluateRequest"
import EvaluateResponse from "../EvaluateResponse"

export default abstract class ContextualEvaluator<REQUEST extends EvaluateRequest, RESPONSE extends EvaluateResponse>
  implements Evaluator<REQUEST, RESPONSE>
{
  abstract supports(request: EvaluateRequest): request is REQUEST

  abstract record(request: REQUEST, response: RESPONSE): void

  protected abstract doEvaluate(request: REQUEST, context: EvaluatorContext): RESPONSE

  /**
   * @override
   */
  evaluate(request: REQUEST, context: EvaluatorContext): RESPONSE {
    if (context.contains(request)) {
      const stack = [...context.stack, request].map((it) => it.toString()).join(" - ")
      throw new Error(`Circular evaluation has occurred [${stack}]`)
    }
    context.addRequest(request)
    try {
      return this.doEvaluate(request, context)
    } finally {
      context.removeRequest(request)
    }
  }
}
